export interface IUpdateHospitalPrescriptionRefillRequest {
  hospitalPrescriptionRefillId: number;
  hospitalPrescriptionId: number;
  hospitalPrescriptionRefillStatusId: number;
  hospitalPrescriptionRowVersion: string;
  requestedPickupDate: string | undefined;
  rowVersion: string;
}

export class UpdateHospitalPrescriptionRefillRequest
  implements IUpdateHospitalPrescriptionRefillRequest
{
  hospitalPrescriptionRefillId: number;
  hospitalPrescriptionId: number;
  hospitalPrescriptionRefillStatusId: number;
  hospitalPrescriptionRowVersion: string;
  requestedPickupDate: string | undefined;
  rowVersion: string;

  constructor(params: IUpdateHospitalPrescriptionRefillRequest) {
    this.hospitalPrescriptionRefillId = params.hospitalPrescriptionRefillId;
    this.hospitalPrescriptionId = params.hospitalPrescriptionId;
    this.hospitalPrescriptionRefillStatusId =
      params.hospitalPrescriptionRefillStatusId;
    this.hospitalPrescriptionRowVersion = params.hospitalPrescriptionRowVersion;
    this.requestedPickupDate = params.requestedPickupDate;
    this.rowVersion = params.rowVersion;
  }

  static ParseUpdateHospitalPrescriptionRefillRequest(
    hospitalPrescriptionRefillId: number,
    hospitalPrescriptionId: number,
    hospitalPrescriptionRefillStatusId: number,
    hospitalPrescriptionRowVersion: string,
    requestedPickupDate: string | undefined,
    rowVersion: string,
  ): IUpdateHospitalPrescriptionRefillRequest {
    return {
      hospitalPrescriptionRefillId,
      hospitalPrescriptionId,
      hospitalPrescriptionRefillStatusId,
      hospitalPrescriptionRowVersion,
      requestedPickupDate,
      rowVersion,
    };
  }
}
